import { Modal } from 'admin-web-ui'
import React from 'react'
import { useAsyncFn } from 'react-use'
import { useAppContext } from '../../../containers/App'
import { globalSignOut } from '../../../utils/cognito'

interface Props {
  visible: boolean
  onCancel: () => unknown
}

export const GlobalSignOutModal: React.FC<Props> = (props) => {
  const { cognitoUser, setCognitoUser } = useAppContext()
  if (!cognitoUser) {
    throw new Error(
      'Cognito user must be available in order to do global sign out.',
    )
  }

  const [okHandlerState, okHandler] = useAsyncFn(async () => {
    return globalSignOut({
      cognitoUser,
      onCognitoUserChanged: setCognitoUser,
    })
  })

  return (
    <Modal
      open={props.visible}
      title="Sign out of all devices?"
      onCancel={props.onCancel}
      onOk={okHandler}
      okButtonProps={{ loading: okHandlerState.loading }}
      width={453}
    >
      <p>Global sign-out of all devices will take up to an hour.</p>
    </Modal>
  )
}
